// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthCallback_root_1uKWO"};